import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { Toaster } from 'react-hot-toast';

import './App.css';
import Amenities from "./Pages/Amenities/Amenities";
import Login from "./Pages/Login/Login";
import Sites from "./Pages/Sites/Sites";
import Users from "./Pages/Users/Users";
import Form from "./Pages/Form/Form";
import AddSite from "./Pages/AddSite/AddSite";
import Units from "./Pages/Units/Units";
import FloorPlans from "./Pages/FloorPlans/FloorPlans";
import Images from './Pages/Images/Images'
import EditSite from "./Pages/AddSite/EditSite";
import { authContext } from "./store/AuthContext";

function App() {
  const authCtx = useContext(authContext);
  const isLoggedIn = authCtx.isLoggedIn;

  let routes = <Switch>
    <Route path="/">
      <Login />
    </Route>
  </Switch>

  if (isLoggedIn === true) {
    routes = <Switch>
      <Route exact path="/amenities">
        <Amenities />
      </Route>
      <Route exact path="/sites">
        <Sites />
      </Route>
      <Route exact path="/sites/add">
        <AddSite />
      </Route>
      <Route exact path="/sites/edit/:id">
        <EditSite />
      </Route>
      <Route exact path="/users">
        <Users />
      </Route>
      <Route exact path="/form">
        <Form />
      </Route>
      <Route exact path="/units">
        <Units />
      </Route>
      <Route exact path="/floor-plans">
        <FloorPlans />
      </Route>
      <Route exact path="/images">
        <Images />
      </Route>
      <Redirect to='/sites' />
    </Switch>
  }

  return (
    <div className="App">
      <Toaster
        position="bottom-center"
        containerClassName="toast-popup"
        reverseOrder={false}
        toastOptions={{
          className: 'toast-popup',
          style: {
            fontSize: '1.8rem'
          }
        }}
      />
      <Router>
        {routes}
      </Router >
    </div>
  );
}

export default App;
